/**
 * Talent module UI labels
 * These are default labels that can be overridden per company
 */
export const TALENT_LABELS = {
  location: "Location",
  locationAddress: "Location Address",
  talent: "Talent",
  talents: "Talents",
  independentProfessionals: "Independent Professionals",
  favoriteTalents: "Favorite Talents",
  talentDetails: "Talent Details",
  skills: "Skills",
  certifications: "Certifications",
  experience: "Experience",
  rating: "Rating",
  reviews: "Reviews",
  independentProfessionalsMap: "Independent Professionals Map",
  favoriteIndependentProfessionals: "Favorite Independent Professionals",
  showMap: "Show Map",
  favorites: "Favorites",
  industries: "Industries",
  noIndustryAdded: "No industry added",
  phonenumber: "Phonenumber",
  searchingIndependentProfessionals: "Searching Independent Professionals...",
  favorited: "Favorited",
  addAsFavorite: "Add as Favorite",
  noSkillAdded: "No skill added",
  noLanguagesAdded: "No languages added",
  languages: "Languages",
  availability: "Availability",
  workStatus: "Work Status",
  notSet: "Not Set",
  // Work status values
  soleProprietor: "Sole Proprietor",
  entrepreneur: "Entrepreneur",
  partTime: "Part Time",
  // Location fallbacks
  unknownCity: "Unknown City",
  unknownState: "Unknown State",
  noEmail: "No Email",
  noPhone: "No Phone",
  // Talent detail labels
  workSuccess: "Work Success",
  totalEarned: "Total Earned",
  work: "Work",
  memberSince: "Member Since",
  // Success messages
  successfullyAddAsFavorite: "Successfully add as favorite",
  successfullyRemoveFromFavorite: "Successfully remove from favorite",
  // Document types
  driverLicense: "Driver License",
  workPermit: "Work Permit",
  insurance: "Insurance",
  // Loading messages
  loadingMaps: "Loading Maps",
  // Talent Drawer labels
  moreInfo: "More Info",
  rate: "Rate",
  commuteRadius: "Commute Radius",
  allowBackgroundCheck: "Allow Background Check",
  allowDrugTest: "Allow Drug Test",
  moreDetail: "More Detail",
  // Talent Profile Panel labels
  about: "About",
  noBioAvailable: "No bio available",
  workExperience: "Work Experience",
  education: "Education",
  degree: "Degree",
  fieldOfStudy: "Field of study",
  present: "present",
  licenseCertificates: "License & Certificates",
  number: "Number #",
  expires: "Expires",
  specialDocuments: "Special Documents",
  untitledDocument: "Untitled Document",
  viewDocument: "View Document",
  contact: "Contact",
  address1: "Address 1",
  address2: "Address 2",
  cityZip: "City / Zip",
  country: "Country",
  monday: "Monday",
  tuesday: "Tuesday",
  wednesday: "Wednesday",
  thursday: "Thursday",
  friday: "Friday",
  saturday: "Saturday",
  sunday: "Sunday",
  backgroundCheck: "Background Check",
  drugTest: "Drug Test",
  validUSCitizenOrHaveWorkVisa: "Valid U.S Citizen or Have a Work Visa",
  // Talent Jobs Panel labels
  typeOfWork: "Type of Work",
  // Talent Reviews Page labels
  reviewsFor: "Reviews For",
  noReviewYet: "No Review, Yet",
  untitledProject: "Untitled Project",
  unknownCompany: "Unknown Company",
  // Talents Fav Page labels
  facebook: "Facebook",
  instagram: "Instagram",
  linkedIn: "LinkedIn",
  successfullyDeleted: "Successfully deleted",
  deleteFromFavorite: "Delete '{name}' from favorite ?",
  // Modal Talent Filter labels
  partTimeProfessional: "Part Time Professional",
  // Common fallbacks
  nA: "n/a",
} as const;

export type TalentLabelKey = keyof typeof TALENT_LABELS;
